import type { StructureName } from "src/api";

import type { StructureCategoryIcons } from "../icons/iconTypes";

export type BuildCategoryName = "industry" | "defense" | "artifacts";

export interface BuildCategory {
  name: BuildCategoryName;
  icon: StructureCategoryIcons;
  structures: StructureName[];
}

export const BUILD_CATEGORIES: readonly BuildCategory[] = [
  {
    name: "industry",
    icon: "categoryIndustry",
    structures: ["store", "research"]
  },
  {
    name: "defense",
    icon: "categoryDefense",
    structures: ["turret", "keystone"]
  },
  {
    name: "artifacts",
    icon: "categoryArtifacts",
    structures: ["altar", "relic", "banner", "well"]
  }
];
